
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    title: {
      type: Boolean,
      required: false,
    },
    hasDivider: {
      type: Boolean,
      required: false,
      default: true,
    },
    columns: {
      type: Array as PropType<number[]>,
      required: false,
    },
  },
  computed: {
    hasTitleSlot(): boolean {
      return !!this.$slots.title;
    },
  },
  methods: {
    columnSize(column: number): any {
      return {
        "min-width": `${column}%`,
      };
    },
  },
});
